import { IWorkspaceUserGroup, WorkspaceUserGroupType, LegacyWorkspaceGroupIds } from "common/interfaces";

export function isUserGroupLibrarians(workspaceUserGroup: IWorkspaceUserGroup) {
    return ((workspaceUserGroup.type === WorkspaceUserGroupType.CUSTOM && workspaceUserGroup.migrationInfo?.originalEntityType === "Organization") || workspaceUserGroup.id === LegacyWorkspaceGroupIds.LIBRARIANS);
}
